// import dependencies
import React from 'react'
import ReactDOM from 'react-dom'
import { Provider as AlertProvider } from 'react-alert'
import AlertTemplate from 'react-alert-template-oldschool-dark'
// import css
import 'semantic-ui-css/semantic.min.css'
import './css/index.css'
// import components
import App from './components/App'
// import registerServiceWorker from './registerServiceWorker';

// import environmental variables from .env file
// require('dotenv').config()

ReactDOM.render(
  <AlertProvider template={AlertTemplate} transition={'fade'}>
    <App />
  </AlertProvider>,
  document.getElementById('root')
)
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js